import { apiClient } from '../api';
import type { ApiResponse } from '@/types/auth';
import type {
  AirtimeNetworksResponse,
  AirtimePurchaseResult,
  AirtimeQuote,
  PurchaseAirtimePayload,
} from '@/types/airtime';

class AirtimeService {
  getNetworks() {
    return apiClient.get<ApiResponse<AirtimeNetworksResponse>>('/users/airtime/networks');
  }

  getQuote(network: string, amount: number) {
    return apiClient.get<ApiResponse<{ quote: AirtimeQuote }>>('/users/airtime/quote', {
      params: { network, amount },
    });
  }

  purchase(payload: PurchaseAirtimePayload) {
    return apiClient.post<ApiResponse<AirtimePurchaseResult>>('/users/airtime/purchase', payload, {
      timeout: 45_000,
    });
  }
}

export const airtimeService = new AirtimeService();
